import angular from 'angular';

// Libraries
import uiModal from 'angular-ui-bootstrap/src/modal';

// Deps
import errorMessageModule from '../../errorMessage';
import translateModuleName from '../../../translation';

// Controller
import ErrorModalController from './errorModal.controller';
import template from './errorModal.html';

const moduleName = 'recaps.editor.modals.error';
let module = angular.module(moduleName, [
  uiModal,
  errorMessageModule.name,
  translateModuleName,
]);

module.controller('ErrorModalController', ErrorModalController);
module.factory('showErrorModal', ['$uibModal', '$translate', ($uibModal, $translate) => {
  return props => {
    let modal = $uibModal.open({
      template: template,
      controller: ErrorModalController,
      controllerAs: 'vm',
      size: props.size || 'sm',
      resolve: {
        title: () => props.title || $translate('ERROR'),
        error: () => props.error || null,
        message: () => props.message || (props.error && props.error.message) || null,
        showAdditionalButton: () => props.showAdditionalButton || false,
        additionalButtonText: () => props.additionalButtonText || '',
        additionalButtonAction: () => props.additionalButtonAction || null
      }
    });
    return modal.result;
  };
}]);

export default module;
